import React from 'react';
import styles from './agencycss.module.scss';

function AgencyBanner(props) {
  // Set CSS custom properties for color customization
  const containerStyle = {
    '--primary-color': props.primaryColor || '#17517b',
    '--secondary-color': props.secondaryColor || '#f26f22',
    '--button-color': props.buttonColor || '#ff3838',
    '--button-hover-color': props.buttonHoverColor || '#e62e2e',
    '--title-text-color': props.titleTextColor || '#fff',
    '--info-text-color': props.infoTextColor || 'transparent',
    '--button-text-color': props.buttonTextColor || '#fff',
    '--button-hover-text-color': props.buttonHoverTextColor || '#fff',
  };

  return (
    <div>
      <div className={styles.announcementBanner} style={containerStyle}>
        <div className={styles.abMain}>
          <h2>
            {props.announcementTitle || 'Agency Markup'}
            <svg
              width="238"
              height="14"
              viewBox="0 0 238 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M169.001 14H229.521C229.74 14 229.952 13.9287 230.125 13.7969L237.219 8.42023C237.715 8.04454 237.751 7.31237 237.295 6.88971L230.145 0.266418C229.96 0.0951512 229.718 0 229.466 0H169.001V14Z"
                fill="#FC6D04"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M118.885 14H179.405C179.623 14 179.835 13.9287 180.009 13.7969L187.103 8.42023C187.598 8.04454 187.635 7.31237 187.178 6.88971L180.029 0.266418C179.844 0.0951512 179.601 0 179.349 0H118.885V14Z"
                fill="#74C14E"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 14H120.066C120.284 14 120.497 13.9287 120.67 13.7969L127.672 8.48986C128.164 8.11692 128.204 7.39163 127.756 6.967L120.692 0.274084C120.506 0.0980911 120.26 0 120.004 0H0V14Z"
                fill="url(#paint0_linear_623_2)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_623_2"
                  x1="0"
                  y1="14"
                  x2="143.885"
                  y2="14"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#006CA7" />
                  <stop offset="1" stopColor="#046EA8" />
                </linearGradient>
              </defs>
            </svg>
          </h2>
          <img
            src={
              props.announcementImage ||
              'https://via.placeholder.com/200x100?text=Announcement'
            }
            alt="Announcement"
          />
        </div>
        <h3 className={styles.abInfo}>
          {props.announcementInfo ||
            '  Now create the Agency Markup for more revenue!'}
        </h3>
        <button className={styles.abBtn} onClick={props.onClick}>
          {props.buttonText || 'Create Agency Markup'}
        </button>
      </div>
    </div>
  );
}

export default AgencyBanner;

